export enum UserType {
  ADMIN = 'Super Administrator',
  USHER = 'Usher',
  COORDINATOR = 'Coordinator',
  DRAW_ADMIN = 'Draw Admin',
  PLAYER = 'Player',
  CASHIER = 'Cashier',
  AUDITOR = 'Auditor',
}
